import React, { useState, createElement, useEffect } from 'react';
import { DialogBase, i18n, StackBase, TypographyBase, IconToComponent, ButtonBase } from '@fmc-digital/ui';
import { useMediaQuery, useTheme } from '@mui/material';
import { ScrollView } from 'native-base';
import parse from 'html-react-parser';
import { logUserEvent } from 'fmc-digital-common';
import { v4 } from 'uuid';
import { accountStatusEvents } from '@constants';

const AccountStatusPopup = ({ open, handleClose, accountStatusTemplate }: any) => {
    const [template, setTemplate] = useState(accountStatusTemplate);
    const { metadata, body } = template;
    const { slotProps } = metadata;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        if (fullScreen) {
            const handleAnchorClick = (event: any) => {
                const link = document.querySelector('a.tag-event[href="tel:855-690-5900"]').innerHTML;
                if (link === event.target.innerHTML) {
                    logUserEvent({
                        ...accountStatusEvents.logEvent.CallUs,
                        uuid: v4()
                    });
                }
            };
            document.addEventListener('click', handleAnchorClick);

            return () => {
                document.removeEventListener('click', handleAnchorClick);
            };
        }
    }, []);

    const RenderChildrenElement = (ele: any, index: number) => {
        switch (ele.type) {
            case 'paragraph':
                return (
                    <TypographyBase key={index} variant="paragraph" sx={template.metadata.slotProps.paragraph.sx}>
                        {parse(i18n.t(ele.content) as string)}
                    </TypographyBase>
                );
            case 'multiparagraph':
                return (
                    <TypographyBase key={index} variant="paragraph" sx={template.metadata.slotProps.multiparagraph.sx}>
                        {parse(i18n.t(ele.content) as string)}
                    </TypographyBase>
                );
            case 'subHeading':
                return (
                    <TypographyBase key={index} variant="subtitle2" sx={template.metadata.slotProps.subHeading.sx}>
                        {parse(i18n.t(ele.content) as string)}
                    </TypographyBase>
                );
            case 'icon':
                return (
                    <StackBase key={index} width={'100%'} alignItems={'center'}>
                        {/*@ts-ignore*/}
                        {createElement(IconToComponent[ele.content], slotProps['icon'])}
                    </StackBase>
                );
            case 'heading':
                return (
                    <TypographyBase key={index} variant="subtitle1" sx={template.metadata.slotProps.heading.sx}>
                        {parse(i18n.t(ele.content) as string)}
                    </TypographyBase>
                );
            default:
                return <TypographyBase key={index}>{parse(i18n.t(ele.content) as string)}</TypographyBase>;
        }
    };

    const renderDialogContent = () => {
        return (
            <ScrollView>
                <StackBase flex={1} marginBottom={4}>
                    {body.map((ele: any, index: number) => RenderChildrenElement(ele, index))}
                </StackBase>
            </ScrollView>
        );
    };

    const renderDialogActions = () => {
        return (
            <ButtonBase variant="contained" onClick={() => handleClose(false)} sx={template.metadata.slotProps.buttonCTA1.sx}>
                Close
            </ButtonBase>
        );
    };

    return (
        <DialogBase
            handleClose={() => {
                handleClose(false);
            }}
            {...slotProps.root}
            fullScreen={fullScreen}
            open={open}
            renderDialogContent={renderDialogContent}
            renderDialogActions={renderDialogActions}
        />
    );
};

export default React.memo(AccountStatusPopup);
